<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <a ref="target" id="target"></a>
    <div v-if="project.UF_VID_BUDGET !== 3 && project.UF_VID_BUDGET < 3">
      <Budget2 :project="project" :step="step" />
    </div>
    <div v-if="project.UF_VID_BUDGET === 3">
      <Budget4 :project="project" :step="step" />
    </div>
    <div v-if="project.UF_VID_BUDGET > 3">
      <Budget4 :project="project" :step="step" />
    </div>
  </div>
  <!--container-fluid-->
</template>

<script>
import Budget2 from "@/components/project/form/partial/Budget2";
import Budget3 from "@/components/project/form/partial/Budget3";
import Budget4 from "@/components/project/form/partial/Budget4";

export default {
  name: "step3",
  components: { Budget3, Budget2, Budget4 },
  props: ["step", "project"]
};
</script>

<style scoped></style>
